import React, { useState, useEffect } from 'react';
import { translations } from '../Text/translations';
import disneyActivationEn from '../../assets/disneyplus/DisneyPlus_Activation_visual_en.png';
import disneyActivationTc from '../../assets/disneyplus/DisneyPlus_Activation_visual_tc.png';

const DisneyPlusActivated = ({ currentLang, nickname, mobilenowid, emailnowid }) => {
  const handleLogonButtonClick = () => {
    window.location.href = 'https://www.disneyplus.com/';
  };
  return (
    <>
      <div className="name">
        <h2 className="name">{translations[currentLang].disneyplusSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].disneyplusSubjectGreeting2}</h2>
      </div>

      <div className="message">
        <p>{translations[currentLang].disneyplusActivated}</p>
      </div>
      <div className="cta-buttons">
        <button className="btn primary" onClick={handleLogonButtonClick}>
          {translations[currentLang].disneyplusStartStreaming}
        </button>
      </div>
      <div className="preview-img">
        <img src={currentLang === 'en' ? disneyActivationEn : disneyActivationTc} alt="" />
      </div>
    </>
  );
};

export default DisneyPlusActivated;